<template>
  <scroll-layout class="details">
    <template slot="header">
      <div v-if="pageButtons.length > 0" class="button-wrap">
        <template v-for="(button, index) in pageButtons">
          <ykc-button
            :key="index"
            v-if="button.enabled"
            v-bind="button"
            @click="button.handleClick(button, $event)">
            {{ button.text }}
          </ykc-button>
        </template>
      </div>
    </template>
    <ykc-detail-plus class="box-card" :labelWidth="130">
      <div slot="header" class="clearfix">
        <span>{{ dealData(formData.name) }}</span>
        <span style="color: #666">{{ ` | ${formData.brand}` }}</span>
      </div>

      <el-col :span="12">
        <ykc-detail-item-plus :label="'充电站ID：'">
          <span>{{ dealData(formData.stationId) }}</span>
        </ykc-detail-item-plus>
      </el-col>
      <el-col :span="12">
        <ykc-detail-item-plus :label="'电站地址：'">
          <span>
            {{ formData.detailAddress }}
          </span>
        </ykc-detail-item-plus>
      </el-col>

      <el-col :span="12">
        <ykc-detail-item-plus :label="'电站联系电话：'">
          <span>
            {{ formData.telephone }}
          </span>
        </ykc-detail-item-plus>
      </el-col>
      <el-col :span="12">
        <ykc-detail-item-plus :label="'站点状态'">
          <span>{{ dealData(formData.startStatusDesc) }}</span>
        </ykc-detail-item-plus>
      </el-col>
    </ykc-detail-plus>

    <ykc-detail-plus class="box-card" :labelWidth="130">
      <div slot="header" class="clearfix">
        <span>价格信息</span>
      </div>
      <ykc-table ref="YkcTable1" :data="firstTableData" :columns="firstTableColumns"></ykc-table>
    </ykc-detail-plus>

    <ykc-detail-plus class="box-card" :labelWidth="130">
      <div slot="header" class="clearfix">
        <span>设备信息</span>
      </div>
      <ykc-table ref="YkcTable3" :data="thirdTableData" :columns="thirdTableColumns">
        <ykc-pagination
          align="right"
          slot="pagination"
          ref="YkcPagination3"
          :total="pageInfo3.total"
          :page-size.sync="pageInfo3.size"
          :current-page.sync="pageInfo3.current"
          @size-change="handlePaginationSizeChange3"
          @current-change="handlePaginationCurrentChange3"></ykc-pagination>
      </ykc-table>
    </ykc-detail-plus>

    <ykc-detail-plus class="box-card" :labelWidth="130">
      <div slot="header" class="clearfix">
        <span>车位信息</span>
      </div>
      <ykc-table ref="YkcTable4" :data="parkTableData" :columns="parkTableColumns">
        <ykc-pagination
          align="right"
          slot="pagination"
          ref="YkcPagination4"
          :total="pageInfo4.total"
          :page-size.sync="pageInfo4.size"
          :current-page.sync="pageInfo4.current"
          @size-change="handlePaginationSizeChange4"
          @current-change="handlePaginationCurrentChange4"></ykc-pagination>
      </ykc-table>
    </ykc-detail-plus>
  </scroll-layout>
</template>

<script>
  import { sessionGetItem } from '@/utils';
  import { stationPage } from '@/service/apis';

  export default {
    name: 'thirdConnectionStationDetail',
    components: {},
    data() {
      return {
        stationId: 0,
        formData: {
          startStatus: 0,
        },
        firstTableData: [],
        firstTableColumns: [
          {
            label: '时段',
            prop: 'priceStartPeriod',
            minWidth: '150px',
            scopedSlots: {
              default: ({ row }) => {
                return (
                  <span>
                    {row.priceStartPeriod}~{row.priceEndPeriod}
                  </span>
                );
              },
            },
          },
          { label: '电费单价(元/度)', prop: 'powerRate', minWidth: '150px' },
          { label: '服务费单价(元/度)', prop: 'serviceRate', minWidth: '150px' },
        ],
        thirdTableData: [],
        thirdTableColumns: [
          { label: '设备ID', prop: 'deviceId', minWidth: '150px' },
          { label: '设备名称', prop: 'deviceName', minWidth: '150px' },
          { label: '额定电压', prop: 'ratedCurrent', minWidth: '150px' },
          { label: '额定电流', prop: 'ratedVoltage', minWidth: '150px' },
          { label: '额定功率', prop: 'ratedPower', minWidth: '150px' },
          {
            label: '设备状态',
            prop: 'status',
            minWidth: '150px',
          },
        ],
        parkTableData: [],
        parkTableColumns: [
          { label: '车位号', prop: 'spaceNo', minWidth: '150px' },
          {
            label: '状态',
            prop: 'enable',
            minWidth: '150px',
            scopedSlots: {
              default: ({ row }) => {
                const startStatus = row.enable ? 'status-blue' : 'status-red';
                return (
                  <span class={['userStatus', startStatus]}>{row.enable ? '启用' : '停用'}</span>
                );
              },
            },
          },
          { label: '区域ID', prop: 'rangeId', minWidth: '150px' },
          { label: '车位ID(spaceId)', prop: 'spaceId', minWidth: '150px' },
          { label: '站点ID(stationId)', prop: 'stationId', minWidth: '150px' },
        ],
        pageInfo3: {
          current: 1,
          size: 10,
          total: 0,
        },
        pageInfo4: {
          current: 1,
          size: 10,
          total: 0,
        },
      };
    },
    computed: {
      pageButtons() {
        return [
          {
            text: '返回',
            type: 'plain',
            enabled: true,
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ];
      },
    },
    created() {
      this.stationId = Number(this.$route.query.stationId);
      this.roleType = sessionGetItem('roleType');
      this.requestDetailList();
      this.requestIntFindByPageList();
      this.requestParkFindByPageList();
    },
    methods: {
      /**
       * 获取详情数据
       */
      requestDetailList() {
        stationPage
          .thirdDetail({ stationId: this.stationId })
          .then(res => {
            if (res !== null) {
              this.formData = res;
              this.firstTableData = res.feeDetailDTOList || [];
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      /**
       * 直联电桩分页查询
       */
      requestIntFindByPageList() {
        const pageInfos = (({ current, size }) => ({ current, size }))(this.pageInfo3);
        const params = {
          ...pageInfos,
          stationId: this.stationId,
        };
        stationPage
          .thirdFindByPageDetail(params)
          .then(res => {
            this.thirdTableData = res.records;
            this.pageInfo3.total = res.total || 0;
          })
          .catch(err => {
            console.log(err);
          });
      },

      /**
       * 车位分页查询
       */
      requestParkFindByPageList() {
        const pageInfos = (({ current, size }) => ({ current, size }))(this.pageInfo4);
        const params = {
          ...pageInfos,
          stationId: this.stationId,
        };
        stationPage
          .findSpaceByPage(params)
          .then(res => {
            this.parkTableData = res.records;
            this.pageInfo4.total = res.total || 0;
          })
          .catch(err => {
            console.log(err);
          });
      },

      /**
       * table---3
       * */
      handlePaginationCurrentChange3(current) {
        this.pageInfo3.current = current;
        this.requestIntFindByPageList();
      },
      /**
       * table---3
       * */
      handlePaginationSizeChange3(size) {
        this.pageInfo3.size = size;
        this.requestIntFindByPageList();
      },
      /**
       * table---4
       * */
      handlePaginationCurrentChange4(current) {
        this.pageInfo4.current = current;
        this.requestParkFindByPageList();
      },
      /**
       * table---4
       * */
      handlePaginationSizeChange4(size) {
        this.pageInfo4.size = size;
        this.requestParkFindByPageList();
      },
      /**
       *
       */
      dealData(data) {
        return data || '——';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .box-card {
    margin-top: 10px;
  }
  .ykc-table {
    .el-table .el-table__row {
      .cell .userStatus {
        padding-left: 8px;
        position: relative;
      }

      .cell .userStatus::after {
        display: block;
        content: '';
        width: 5px;
        height: 5px;
        border-radius: 100%;
        background: #d0021b;
        position: absolute;
        top: 5.5px;
        left: 0;
      }

      .cell .status-blue::after {
        background: #4d8cfd;
      }

      .cell .status-green::after {
        background: #02c498;
      }

      .cell .status-black::after {
        background: #9b9b9b;
      }
    }

    .sealBtn {
      color: #4d8cfd;
      cursor: pointer;
    }
    .file-link {
      color: #4d8cfd;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .detailTabs {
    ::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item {
      width: 160px !important;
    }
  }

  .row-item {
    padding: 0px 4px;
    font-size: 10px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    border-radius: 7px;
    line-height: 23px;
    display: inline-block;
  }

  .row-item-txt {
    padding: 0 4px;
    min-width: 30px;

    text-align: center;
    line-height: 23px;
    display: inline-block;
  }

  .row-green {
    background: linear-gradient(180deg, #07c160 0%, #02e495 100%);
  }

  .row-blue {
    background: linear-gradient(180deg, #1779fe 0%, #72aeff 100%);
  }
</style>
